import '@core/extensions/string.extensions';
import '@core/extensions/form-group.extension';

import { trigger, transition, style, animate } from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { filter, switchMap } from 'rxjs';
import { AuthService } from '@core/auth/auth.service';
import { FrazatService } from '@core/services/frazat.service';
import { OperatoriFaqjaService } from '@core/services/operatori-faqja.service';
import { FjalaPerzgjedhurStrukturaService } from '@core/services/fjala-perzgjedhur-struktura.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('headerAnim', [
      transition(':enter', [style({ transform: 'translateY(-100%)' }), animate('0.3s ease-in-out', style({ transform: 'translateY(0)' }))]),
      transition(':leave', [style({ transform: 'translateY(0)' }), animate('0.3s ease-in-out', style({ transform: 'translateY(-100%)' }))]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean = false;

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private authService: AuthService,
    private frazatService: FrazatService,
    private operatoriFaqjaService: OperatoriFaqjaService,
    private fjalaPerzgjedhurStrukturaService: FjalaPerzgjedhurStrukturaService,
  ) {
    this.registerIcons();
  }

  ngOnInit(): void {
    this.authService.isLoggedInAsLinguist$
      .pipe(
        filter((isAuthenticated) => isAuthenticated),
        switchMap(() => {
          return this.frazatService.dataLoaded$.pipe(filter((loaded) => loaded));
        })
      )
      .subscribe((isLoggedIn) => {
        this.isLoggedIn = isLoggedIn;
      });

    this.operatoriFaqjaService.updateOnChanges().subscribe();
    this.fjalaPerzgjedhurStrukturaService.updateOnChanges().subscribe();
  }

  private registerIcons() {
    this.matIconRegistry.addSvgIcon(`crown`, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/crown.svg'));
    this.matIconRegistry.addSvgIcon(`as_dots`, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/3dots.svg'));
    this.matIconRegistry.addSvgIcon(`as_a_plus`, this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/addword.svg'));
    this.matIconRegistry.addSvgIcon(`as_a_plus_time`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/quickword.svg`));
    this.matIconRegistry.addSvgIcon(`as_structure`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/structure.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_attachment`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/attachment.svg`));
    this.matIconRegistry.addSvgIcon(`as_audio`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/audio.svg`));
    this.matIconRegistry.addSvgIcon(`as_back`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/back.svg`));
    this.matIconRegistry.addSvgIcon(`as_collapse`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/collapse.svg`));
    this.matIconRegistry.addSvgIcon(`as_comments`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/comments.svg`));
    this.matIconRegistry.addSvgIcon(`as_copy`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/copy.svg`));
    this.matIconRegistry.addSvgIcon(`as_crown`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/kingidic.svg`));
    this.matIconRegistry.addSvgIcon(`as_delete`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/delete.svg`));
    this.matIconRegistry.addSvgIcon(`as_blog`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/blog.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_filter`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/filter.svg`));
    this.matIconRegistry.addSvgIcon(`as_history`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/history.svg`));
    this.matIconRegistry.addSvgIcon(`as_home`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/home.svg`));
    this.matIconRegistry.addSvgIcon(`as_jump`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/jump.svg`));
    this.matIconRegistry.addSvgIcon(`as_save_and_next`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/nextandsave.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_cancel_and_next`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/nextnosave.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_save`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/save.svg`));
    this.matIconRegistry.addSvgIcon(`as_notes`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/notes.svg`));
    this.matIconRegistry.addSvgIcon(`as_paste`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/paste.svg`));
    this.matIconRegistry.addSvgIcon(`as_photo`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/photo.svg`));
    this.matIconRegistry.addSvgIcon(`as_plus`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/plus.svg`));
    this.matIconRegistry.addSvgIcon(`as_save_and_back`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/previusandsave.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_cancel_and_back`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/previusnosave.svg`)); //
    this.matIconRegistry.addSvgIcon(`as_settings`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/settings.svg`));
    this.matIconRegistry.addSvgIcon(`as_shortcut`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/shortcut.svg`));
    this.matIconRegistry.addSvgIcon(`as_dictionary`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/dictionaries.svg`));
    this.matIconRegistry.addSvgIcon(`as_video`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/video.svg`));
    this.matIconRegistry.addSvgIcon(`as_switchlang`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/switchlang.svg`));
    this.matIconRegistry.addSvgIcon(`as_secondary`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/secondary.svg`));
    this.matIconRegistry.addSvgIcon(`as_direkt`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/direkt.svg`));
    this.matIconRegistry.addSvgIcon(`as_indirekt`, this.domSanitizer.bypassSecurityTrustResourceUrl(`../assets/icons/indirekt.svg`));
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    if (this.authService.hasValidToken()) {
      this.operatoriFaqjaService.updateOnChanges(0, 0).toPromise();
      this.fjalaPerzgjedhurStrukturaService.updateOnChanges(0, 0).toPromise();
    }
  }
}
